import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { useOpponentsListSelector } from '@gem/call/CallView/hooks/useOpponentsListSelector/useOpponentsListSelector';
import { useShareScreenToggle } from '@gem/call/CallView/hooks/useShareScreenToggle/useShareScreenToggle';

export interface IGroupCallPresenter {
  opponentsList: readonly Opponent[];
  opponentsLength: number;
  isGridLayoutView: boolean;
  isSpeakerView: boolean;
  call: Call;
  setOpponentsList(opponentsList: readonly Opponent[]): void;
}

export const useGroupCallPresenter = (): IGroupCallPresenter => {
  const context = useCallContext();
  const opponentsList = useOpponentsListSelector();

  const presenter = useLocalObservable<IGroupCallPresenter>(() => ({
    opponentsList: opponentsList,

    get call(): Call {
      return context.call;
    },

    get opponentsLength(): number {
      return presenter.opponentsList.length || 0;
    },

    get isGridLayoutView(): boolean {
      return presenter.call.viewState.isGridLayout || presenter.opponentsLength < 2;
    },

    get isSpeakerView(): boolean {
      return !presenter.call.viewState.isGridLayout && presenter.opponentsLength > 1;
    },

    setOpponentsList(opponentsList: readonly Opponent[]): void {
      presenter.opponentsList = opponentsList;
    },
  }));

  useEffect(() => {
    presenter.setOpponentsList(opponentsList);
  }, [opponentsList]);

  useShareScreenToggle();

  return presenter;
};
